const DEFAULT_PREPARATION_DAYS = 7;
const MAX_PREPARATION_DAYS = 365;

const normalizePreparationDays = (value, fallback = DEFAULT_PREPARATION_DAYS) => {
  if (value === undefined || value === null || String(value).trim() === '') return fallback;
  const parsed = Number(value);
  return Number.isInteger(parsed) && parsed >= 0 && parsed <= MAX_PREPARATION_DAYS
    ? parsed
    : fallback;
};

const formatBusinessDays = (value) => {
  const days = normalizePreparationDays(value);
  return `${days} business day${days === 1 ? '' : 's'}`;
};

module.exports = {
  DEFAULT_PREPARATION_DAYS,
  MAX_PREPARATION_DAYS,
  normalizePreparationDays,
  formatBusinessDays,
};
